import { useAuthContext } from "../hooks/use-auth-context.js";
import { jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from "react-router-dom";

//#region src/client/components/AuthorizedOutlet.tsx
const AuthorizedRoute = ({ children }) => {
	const { isAuthenticated, signIn, disableAuthFlows } = useAuthContext();
	const { pathname, search } = useLocation();
	if (!isAuthenticated) {
		if (disableAuthFlows) return /* @__PURE__ */ jsx(Navigate, {
			to: "/",
			replace: true
		});
		signIn(`${pathname}${search}`);
		return null;
	}
	return children;
};
const AuthorizedOutlet = () => /* @__PURE__ */ jsx(AuthorizedRoute, { children: /* @__PURE__ */ jsx(Outlet, {}) });

//#endregion
export { AuthorizedOutlet, AuthorizedRoute };